import router from '../router';

export default {
  changeSelectedHomeWork(state, token) {
    state.works.filter(work => work.inHome).forEach(work => {
      work.selected = work.id === token;
    });
  },
  changeSelectedWork(state, token) {
    state[token.group].forEach(work => {
      work.selected = work.id === token.id
    });
  },
  openVideo(state, token) {
    if (token) {
      router.replace('?' + token.id);
      state[token.group].forEach(work => {
        work.selected = work.id === parseInt(token.id)
      });
    }
    state.videoType = token.group
    state.showVideo = true;
    document.querySelector('body').style.overflow = 'hidden';
  },
  closeVideo(state) {
    state.videoType = ''
    state.showVideo = false;
    document.querySelector('body').style.overflow = 'hidden auto';
    const videoId = location.hash.split('?')[1];
    if (videoId) router.replace('');
  },
  toggleMenu(state, token) {
    state.showMenu = token;
  },
  changeSelectedDirector(state, token) {
    state.directors.filter(director => director.show).forEach((director, i) => {
      director.selected = i === token;
    })
  },
  writeItem(state, token) {
    state[token.item] = token.data;
  },
  writeConfig(state, config) {
    state.config = config;
  },
  toggleBars(state) {
    state.openedBars = !state.openedBars;
  },
  cleanStore(state) {
    const getDefaultState = () => {
      return {
        showVideo: false,
        showMenu: false,
        openedBars: false,
        baseUrl: '/umbraco/api/',
        lang: 'en',
        works: [],
        teamMembers: [],
        locations: [],
        clients: [],
        directors: [],
        homeCopy: {},
        worksCopy: {},
        locationsCopy: {},
        directorsCopy: {},
        contactsCopy: {},
        aboutusCopy: {},
        clientsCopy: {},
        config: {}
      }
    }
    Object.assign(state, getDefaultState())
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js